<template>
    <contact-form-section
        class="contact-form-section-module"
        :title="attributes.contactForm_title"
        :text="attributes.text"
        :contact-address="attributes.contact_address"
        :survey="attributes.asyncData.survey"
        :op-code="attributes.op_code"
        :submit-button-text="attributes.submit_button_text"
        :success-title="attributes.success_title"
        :success-text="attributes.success_text"
    />
</template>

<script>
    import ContactFormSection from '../../../organisms/ContactFormSection/ContactFormSection';

    export default {
        name: 'contact-form-section-module',

        components: { ContactFormSection },

        props: {
            attributes: {
                type: Object,
                default: () => ({}),
            },
        },

        async asyncData({ store, error, attributes }) {
            try {
                const survey = await store.dispatch('atreemo/getSurvey', attributes.op_code);

                return {
                    survey,
                };
            } catch (e) {
                error({
                    statusCode: e.response.status,
                    message: e.response.message,
                });
            }
        },
    };
</script>
